import Swiper from 'swiper';

export default function () {
    new Swiper('.swiper-headerslider', {
        effect: 'fade',
        loop: true,
        autoplay: true,
        speed: 3000
    });
}

new Swiper('.swiper-ambassadors', {
    slidesPerView: 'auto',
    centeredSlides: false,
    effect: 'slide',
    grabCursor: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    watchOverflow: true,
    spaceBetween: 30,
    navigation: {
        nextEl: '.c-ambassadorsnav___item__next',
        prevEl: '.c-ambassadorsnav___item__prev'
    },
    breakpoints: {
        768: {
            slidesPerView: 'auto',
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 30

        },
        576: {
            slidesPerView: 1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 30
        }
    }
});
